import { FC } from "react";
import { Anchor, Image } from "@mantine/core";
import { Link } from "react-router-dom";
import { getPresentationParamsForOrigin } from "../getPresentationParamsForOrigin.ts";

interface LogoProps {
  to: string;
}

export const Logo: FC<LogoProps> = (props) => {
  const { to } = props;

  return (
    <Anchor component={Link} to={to} underline="never">
      <Image
        src={getPresentationParamsForOrigin().logo.dark}
        fit="contain"
        h={37}
        alt={`Logo: ${getPresentationParamsForOrigin().competitionName}`}
        style={{ maxWidth: 37 * 5 }}
      />
    </Anchor>
  );
};
